import { aoBasisgegevensSettings } from './amsterdamOverspanningen/basisgevens/aoBasisgegevensSettings';
import { aoInspectieOverspanningen } from './amsterdamOverspanningen/inspectieOverspanningen/aoInspectieOverspanningen';
import { crowBeeldkwaliteitSettings } from './crowBeeldkwaliteit/crowBeeldkwaliteitSettings';
import { droneLabelSettings } from './inspectionLabel/droneLabel/droneLabelSettings';
import { rovLabelSettings } from './inspectionLabel/rovLabel/rovLabelSettings';
import { nen3140Settings } from './nen3140/nen3140Settings';
import { verificatieBerekeningSettings } from './verificatieBerekening/verificatieBerekeningSettings';

export const customInspectionTypeSettings = {
    [droneLabelSettings.inspectionStandardType]: droneLabelSettings,
    [rovLabelSettings.inspectionStandardType]: rovLabelSettings,
    [verificatieBerekeningSettings.inspectionStandardType]: verificatieBerekeningSettings,
    [nen3140Settings.inspectionStandardType]: nen3140Settings,
    [aoBasisgegevensSettings.inspectionStandardType]: aoBasisgegevensSettings,
    [aoInspectieOverspanningen.inspectionStandardType]: aoInspectieOverspanningen,
    [crowBeeldkwaliteitSettings.inspectionStandardType]: crowBeeldkwaliteitSettings,
};

export function getCustomInspectionStandardTypSettings() {
    return Object.values(customInspectionTypeSettings);
}
